// eslint-disable-next-line import/prefer-default-export
export const URL = {
  SIGN_UP: '/users',
  SIGN_IN: '/sessions',
  REFRESH: '/refresh',
  RESET_PASSWORD: '/recovery',
  RECOVER_PASSWORD: '/recovery/changepassword',
  CONFIRM_EMAIL: '/users/confirm',
  COMBINATION: '/combination',
  COMBINATION_FREE: '/free/combination',
  PLO5COMBINATION: '/5card/combination',
  SITUATION: '/situation',
  PLO5SITUATION: '/5card/situation',
  GAME: '/game/combo',
  FREE_GAME: '/game/free/combo',
  PLO5GAME: '/5card/game/combo',
  GAME_OPTION: '/game/option',
  FIRST_PAIR: '/firstpair',
  PLO5FIRST_PAIR: '/5card/first',
  PLO5SECOND_PAIR: '/5card/second',
  PROFILE: '/whoami',
  PAY: '/pay',
  TRIAL: '/trial',
  CREATE_CHECKOUT_SESSION: '/create-checkout-session',
  CANCEL_SUB: '/cancel-sub',
  REACTIVATE_SUB: '/reactivate-sub',
  GET_SIMILAR: '/similar',
  GET_SIMILAR_FREE: '/free/similar',
  GET_SIMILARPLO5: '/5card/similar',
  GAME_WRONG: '/game/wrong',
  GAME_WRONGPLO5: '/5card/game/wrong',
  RESET_GAME: '/game/reset',
  RESET_GAME_FREE: '/game/free/reset',
  RESET_GAMEPLO5: '/5card/game/reset',
  OPEN_STATS: '/game/open',
  OPEN_STATSPLO5: '/5card/game/open',
  UPGRADE_COST: '/upgrade-cost',
  UPGRADE: '/upgrade',
  GET_RESULTS: '/stat',
  GET_RESULTS_FREE: '/free/stat',
  GET_RESULTS_3BET: '/stat/3bet',
  GET_RESULTS_4BET: '/stat/4bet',
  GET_RESULTS_EASY: '/stat/easy',
  GET_RESULTS_PLO5: '/5card/stat',
  GET_RESULTS_3BET_PLO5: '/5card/stat/3bet',
  GET_RESULTS_4BET_PLO5: '/5card/stat/4bet',
  GET_RESULTS_EASY_PLO5: '/5card/stat/easy',
  GET_MISTAKES: '/game/mistakes',
  GET_MISTAKES_FREE: '/game/free/mistakes',
  GET_MISTAKESPLO5: '/5card/game/mistakes',
  REF_SETTINGS: '/referral/settings',
  REF_PAYMENTS: '/referral/payments',
  REF_USERS: '/referral/users',
  WITHDRAW: '/referral/payments/withdraw',
  CARD_COLOR: '/cardcolor',
  HERO_COLOR: '/herocardcolor',
  POSTFLOP_SITUATION: '/flop/situation',
  POSTFLOP_SIMILAR: '/flop/similar',
  PLO5_POSTFLOP_SITUATION: '/5card/flop/situation',
  PLO5_POSTFLOP_SIMILAR: '/5card/flop/similar',
  POSTFLOP_COMBO: '/flop/combo',
  PLO5_POSTFLOP_COMBO: '/5card/flop/combo',
  POSTFLOP_COMBO_RESULTS: '/flop/combo-results',
  PLO5_POSTFLOP_COMBO_RESULTS: '/5card/flop/combo-results',
  POSTFLOP_STAT: '/flop/stat',
  PLO5_POSTFLOP_STAT: '/5card/flop/stat',
};
